import classNames from "classnames";
import React from "react";

interface IProps {
  left: string;
  right: string | React.ReactNode;
  className?: string | classNames.ArgumentArray;
}

function Row({ left, right, className }: IProps) {
  return (
    <div className={classNames("flex justify-between", className)}>
      <span>{left}</span>
      <span>{right}</span>
    </div>
  );
}

export default Row;
